import DailyCompaniesComponent from 'components/marketingSite/dailyCompanies/DailyCompaniesComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type DailyCompaniesPageProps = WithBaseUrl;

const DailyCompaniesPage: React.FC<DailyCompaniesPageProps> = ({ baseUrl }) => {
  const { t } = useI18n('manfred-daily');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('manfred-daily.page_title')}
        desc={t('manfred-daily.page_description')}
        url={APP_URLS.manfredDailyCompanies}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_manfreddaily_companies.png'
        )}`}
        indexable={true}
      />
      <DailyCompaniesComponent />
    </>
  );
};

export default DailyCompaniesPage;

export const getStaticProps: GetStaticProps<DailyCompaniesPageProps> = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'manfred-daily'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
